import path from 'path';
import fs from 'fs';
import { promisify } from 'util';
import { IS_PC_IN_WIN } from '@/common/constant/platform';

export async function createLocalDir(dirPath: string, maxDeep = 20): Promise<Array<string>> {
  const rootDirPath = path.dirname(dirPath);
  const createList = new Array<string>();

  if (maxDeep <= 0) {
    throw { code: 'over max deep' };
  }
  let isExist = await promisify(fs.exists)(rootDirPath);
  if (!isExist) {
    const retCreateList = await createLocalDir(rootDirPath, maxDeep - 1);
    retCreateList.forEach(item => {
      createList.push(item);
    });
  }

  isExist = await promisify(fs.exists)(dirPath);
  if (!isExist) {
    await promisify(fs.mkdir)(dirPath);
    createList.push(dirPath);
  } else {
    const stats = await promisify(fs.stat)(dirPath);
    if (stats.isFile()) {
      throw { code: 'create dir have file' };
    }
  }
  return createList;
}

export async function deleteLocalDir(dirPath: string) {
  const isExist = await promisify(fs.exists)(dirPath);
  if (!isExist) {
    return true;
  }

  const list = await getLocalDirectoryInfo(dirPath);
  if (list.length === 0) {
    await promisify(fs.rmdir)(dirPath);
    return;
  }

  await Promise.all(
    list.map(async item => {
      const filePath = path.join(dirPath, item);
      await promisify(fs.unlink)(filePath);
    }),
  ).catch(error => {
    throw error;
  });

  await promisify(fs.rmdir)(dirPath);
  return true;
}

export async function getLocalDirectoryInfo(dirPath: string) {
  return await promisify(fs.readdir)(dirPath);
}

export async function isDirectoryEmpty(path: string) {
  try {
    const fileList = await getLocalDirectoryInfo(path);
    return fileList.length === 0;
  } catch (err) {
    console.error('isDirectoryEmpty error', err);
  }
  return 0;
}

export function isLocalPathValid(localPath: string) {
  if (IS_PC_IN_WIN && localPath.replace(/^.*(\/|\\)/, '') === '') {
    throw {
      code: 'NotSupportRootDrive',
    };
  }

  const extName = path.extname(localPath).toLowerCase();
  if (extName === '.app') {
    throw {
      code: 'AppFileNotSupported',
    };
  }

  const paths = localPath.split(path.sep);
  if (paths.length >= 2) {
    const rootFolder = paths[1].toLowerCase();
    if (rootFolder === 'applications') {
      throw {
        code: 'AppFileNotSupported',
      };
    }
  }
  return true;
}
